<template>
    <div style="margin: 10%;">
    <template v-if="!$store.getters.isAuthenticated">
        <Signin/>
    </template>
    <template v-else>

        <t-form
          :onSubmit="submitBillingAddress"
          id="billing_address_form"
          :schema="computedSchema"
        >
  
          <t-checkbox
              name="is_seller_ships"
              v-model="sellerShippingLogistics.is_seller_ships"
              :label="'I will handle shipping this item to the designated destination.'"
          />
      
          <template v-if="!sellerShippingLogistics.is_seller_ships">
              <div> <b> Confirm Your item's location </b> </div><br>
  
              <div class="dashboard-row">
                <div class="input-title"><span>{{$translation($websiteText().my_profile_address)}}</span></div>
                <div class="input-content" playwright-id='billing-address'>
                  <t-input-text
                    rootStyle="width:inherit"
                    id="locationTextField"
                    v-model="sellerShippingLogistics.address"
                    :placeholder="$translation($websiteText().my_profile_address_placeholder)"
                    name="address"
                    style="width: 100%"
                    @input="init()"
                    :autocomplete="'off'"
                    :ariaAutocomplete="'none'"
                    :disabled = 'disabled'
                  ></t-input-text>
                </div>
              </div>
              
              <div class="dashboard-row">
                <div class="input-title"><span>{{$translation($websiteText().my_profile_street)}}</span></div>
                <div class="input-content" playwright-id='billing-street'>
                  <t-input-text
                    rootStyle="width:inherit"
                    v-model="sellerShippingLogistics.street_name"
                    name="street_name"
                    :placeholder="$translation($websiteText().my_profile_street)"
                    :disabled = 'disabled'
                  ></t-input-text>
                </div>
              </div>
              <div class="dashboard-row">
                <div class="input-title"><span>{{$translation($websiteText().my_profile_zip)}}</span></div>
                <div class="input-content" playwright-id='billing-zip-code'>
                  <t-input-text
                    rootStyle="width:inherit"
                    v-model="sellerShippingLogistics.zip"
                    name="zip"
                    :placeholder="$translation($websiteText().my_profile_zip)"
                    :disabled = 'disabled'
                  ></t-input-text>
                </div>
              </div>
              <div class="dashboard-row">
                <div class="input-title"><span>{{$translation($websiteText().my_profile_city)}}</span></div>
                <div class="input-content" playwright-id='billing-city'>
                  <t-input-text
                    rootStyle="width:inherit"
                    v-model="sellerShippingLogistics.city"
                    name="city"
                    :placeholder="$translation($websiteText().my_profile_city)"
                    :disabled = 'true'
                  ></t-input-text>
                </div>
              </div>
              <div class="dashboard-row">
                <div class="input-title"><span>{{$translation($websiteText().my_profile_state)}}</span></div>
                <div class="input-content" playwright-id='billing-state'>
                  <t-input-text
                    rootStyle="width:inherit"
                    v-model="sellerShippingLogistics.state"
                    name="state"
                    :placeholder="$translation($websiteText().my_profile_state)"
                    :disabled = 'true'
                  ></t-input-text>
                </div>
              </div>
  
              <div class="dashboard-row">
                <div class="input-title"><span>{{$translation($websiteText().my_profile_country)}}</span></div>
                <div class="input-content" playwright-id='billing-country'>
                  <t-input-text
                    rootStyle="width:inherit"
                    v-model="sellerShippingLogistics.country"
                    name="country"
                    :placeholder="$translation($websiteText().my_profile_country)"
                    :disabled='true'
                  ></t-input-text>
                </div>
              </div>
              <br><br>
              <div><b>Confirm your item's weight and dimensions </b></div><br>
  
              <div class="dashboard-row">
                <div class="input-title"><span>{{$translation($websiteText().sell_weight)}}</span></div>
  
                <div class="input-content">
                  <t-input-text
                    v-model="sellerShippingLogistics.weight"
                    name="weight"
                    :placeholder="'weight'"
                    rootStyle="width:inherit"
                    :type="'number'"
                    />
                </div>
              </div>
  
  
              <div class="dashboard-row">
                <div class="input-title"><span>{{$translation($websiteText().sell_height)}}</span></div>
  
                <div class="input-content">
                  <t-input-text
                    v-model="sellerShippingLogistics.height"
                    name="height"
                    :placeholder="'height'"
                    rootStyle="width:inherit"
                    :type="'number'"
                    />
                </div>
              </div>
  
              <div class="dashboard-row">
                <div class="input-title"><span>{{$translation($websiteText().sell_length)}}</span></div>
  
                <div class="input-content">
                  <t-input-text
                    v-model="sellerShippingLogistics.length"
                    name="length"
                    :placeholder="'length'"
                    :type="'number'"
                    rootStyle="width:inherit"
                    />
                </div>
              </div>
  
              <div class="dashboard-row">
                <div class="input-title"><span>{{$translation($websiteText().sell_width)}}</span></div>
  
                <div class="input-content">
                  <t-input-text
                    v-model="sellerShippingLogistics.width"
                    name="width"
                    :placeholder="'width'"
                    rootStyle="width:inherit"
                    :type="'number'"
                  />
  
                </div>
              </div>
  
              <t-checkbox
                name="seller_add_insurance"
                v-model="sellerShippingLogistics.seller_add_insurance"
                :label="'I want to add insurnce on this shipping.'"
              />
  
  
          </template>
              
          <template v-else>
              <div class="dashboard-row">
                <div class="input-title"><span>Tracking Link</span></div>
                <div class="input-content" playwright-id='billing-country'>
                  <t-input-text
                    rootStyle="width:inherit"
                    v-model="sellerShippingLogistics.tracking_link"
                    name="tracking_link"
                    :placeholder="'Tracking Link'"
                  ></t-input-text>
                </div>
              </div>
          </template>
          
          <div class="dashboard-row" playwright-id='billing-save-button'>
            <t-button
              :color="'primary-color'"
              v-if="showSave == true"
              style="margin-left: auto"
              :label="$translation($websiteText().website_generals_save_btn)"
              type="submit"
              formSubmit="billing_address_form"
              :onClick="submitValidate"
            />
          </div>
        </t-form>
    </template>
    </div>
  </template>
  
  <script>
  import { computed, reactive } from "@vue/reactivity";
  import TInputText from "../../../common/components/input-text/TInputText.vue";
  import TForm from "../../../common/components/TForm.vue";
  import TButton from "../../../common/components/buttons/TButton.vue";
  import * as Yup from "yup";
  import store from "../../../store";  
  import GooglePlacesHelper from "../../../common/helpers/GooglePlacesHelper";
  import { SHOW_TOAST_MESSAGE } from "../../../common/store/actions";
  import GeneralHelper from "../../../common/helpers/GeneralHelper";
  import phoneCodes from "../../../common/store/phoneCodes";
  import TCheckbox from "../../../common/components/controls/TCheckbox.vue";
  import { useRoute, useRouter } from "vue-router";
  import { GET_SELLER_SHIPPING_LOGISTICS, UPDATE_SELLER_SHIPPING_LOGISTICS } from "../store/actions";

import Signin from "../../authentication/components/Signin.vue";

  export default {
    components: {
      TInputText,
      TCheckbox,
      TForm,
      TButton,
      Signin,
    },
    mounted() {
      let route = useRoute()
      this.$store.dispatch(GET_SELLER_SHIPPING_LOGISTICS, route.params['order_kit_id']).then((response)=>{  
        this.sellerShippingLogistics.state = response.data.state
        this.sellerShippingLogistics.street_name = response.data.street_name
        this.sellerShippingLogistics.zip = response.data.zip
        this.sellerShippingLogistics.city = response.data.city
        this.sellerShippingLogistics.country = response.data.country
        this.sellerShippingLogistics.is_seller_ships = response.data.is_seller_ships
        this.sellerShippingLogistics.tracking_link = response.data.tracking_link
        this.sellerShippingLogistics.order_kit_id = response.data.order_kit_id

      })
    },
    watch: {
        "$store.getters.isAuthenticated": {
            handler(newValue, oldValue) {
                if(newValue)
                {
                    this.$store.dispatch(GET_SELLER_SHIPPING_LOGISTICS, this.$route.params['order_kit_id']).then((response)=>{  
                        this.sellerShippingLogistics.state = response.data.state
                        this.sellerShippingLogistics.street_name = response.data.street_name
                        this.sellerShippingLogistics.zip = response.data.zip
                        this.sellerShippingLogistics.city = response.data.city
                        this.sellerShippingLogistics.country = response.data.country
                        this.sellerShippingLogistics.is_seller_ships = response.data.is_seller_ships
                        this.sellerShippingLogistics.tracking_link = response.data.tracking_link
                        this.sellerShippingLogistics.order_kit_id = response.data.order_kit_id

                    })
                }
            },
            deep: true,
        },
    },
    computed: {
    customer() {
      return this.$store.getters.customer;
    }
  },
    setup(props, { emit }) {
      let route = useRoute()
      let router = useRouter()
      let sellerShippingLogistics = reactive(props.data_);
      sellerShippingLogistics.is_seller_ships = false
      let autocomplete = null;
      

      const computedSchema = computed(() => {
            let rules = {}
            if (!sellerShippingLogistics.is_seller_ships)
            {
                rules['city'] = Yup.string().required().label("City")
                rules['country'] = Yup.string().required().label("Country")
                rules['state'] = Yup.string().required().label("State")
                rules['street_name'] = Yup.string().required().label("Street")
                rules['zip'] = Yup.string().required().label("Zip Code")

                rules['width'] = Yup.number().nullable().required()
                //.min(categoryVolume?categoryVolume*0.8/this.dimensions.values.height/this.dimensions.values.length:0, `The volume should be greater than ${categoryVolume*0.8}`)
                //.max(categoryVolume?categoryVolume*1.2/this.dimensions.values.height/this.dimensions.values.length:1000, `The volume should be less than ${categoryVolume*1.2}`)

                rules['length'] = Yup.number().nullable().required()
                //.min(categoryVolume?categoryVolume*0.8/this.dimensions.values.height/this.dimensions.values.width:0, `The volume should be greater than ${categoryVolume*0.8}`)
                //.max(categoryVolume?categoryVolume*1.2/this.dimensions.values.height/this.dimensions.values.width:1000, `The volume should be less than ${categoryVolume*1.2}`)

                rules['height'] = Yup.number().nullable().required()
                //.min(categoryVolume?categoryVolume*0.8/this.dimensions.values.length/this.dimensions.values.width:0, `The volume should be greater than ${categoryVolume*0.8}`)
                //.max(categoryVolume?categoryVolume*1.2/this.dimensions.values.length/this.dimensions.values.width:1000, `The volume should be less than ${categoryVolume*1.2}`)
                
                rules['weight'] = Yup.number().nullable().required()
                //.min(this.categoryDimensions.values.weight*0.8||0)
                //.max(this.categoryDimensions.values.weight*1.2||1000)
            }
            else{
                rules['tracking_link'] = Yup.string().required().label("Tracking Link")
            }

            return Yup.object().shape(rules)
      })
  
      const init = () => {
        var input = document.getElementById("locationTextField");
        if(!autocomplete) 
        {
          autocomplete = new google.maps.places.Autocomplete(input)
          google.maps.event.addListener(autocomplete, "place_changed", function() {
            var place = autocomplete.getPlace();
            if (place.business_status) {
              sellerShippingLogistics.company_name = place.name
            }
            if(place.international_phone_number){
              for(var i = 0; i < place.address_components.length; i++) {
                var addressObj = place.address_components[i];
                for(var j = 0; j < addressObj.types.length; j++) {
                  if (addressObj.types[j] === 'country') {
                    sellerShippingLogistics.phone_dial = phoneCodes.find(phoneCode=>phoneCode.name==addressObj.long_name).dial_code
                    sellerShippingLogistics.phone_number = place.formatted_phone_number
                    break
                  }
                }
              } 
            }
            var details = GooglePlacesHelper.extract(place.address_components);
            sellerShippingLogistics.street_name = (details.route||"").trim();
            sellerShippingLogistics.country = (details.country||"").trim();
            sellerShippingLogistics.zip = (details.zip||"").trim();
            sellerShippingLogistics.state = (details.state||"").trim();
            sellerShippingLogistics.city = (details.city||"").trim();
            sellerShippingLogistics.address = (place.formatted_address||"").trim()
          });
  
          input.addEventListener('blur', function (){
            setTimeout(function (){
    
              var service = new google.maps.places.AutocompleteService();
              service.getPlacePredictions({ input: input.value }, predictionsCallback);
              function predictionsCallback(predictions, status) {
                if (status != google.maps.places.PlacesServiceStatus.OK) return;
                
                let place_id = predictions[0].place_id
                const geocoder = new google.maps.Geocoder();
                geocoder
                .geocode({ placeId: place_id })
                .then(({ results }) => {
                  if (results[0]) {
                    var details = GooglePlacesHelper.extract(results[0].address_components);
                    sellerShippingLogistics.street_name = (details.route||"").trim();
                    sellerShippingLogistics.country = (details.country||"").trim();
                    sellerShippingLogistics.zip = (details.zip||"").trim();
                    sellerShippingLogistics.state = (details.state||"").trim();
                    sellerShippingLogistics.city = (details.city||"").trim();
                    sellerShippingLogistics.address = (results[0].formatted_address||"").trim()
                  } else {
                    window.alert("No results found");
                  }
                })
                .catch((e) => window.alert("Geocoder failed due to: " + e));
  
                }
                        
            }, 500);
            
          })
        }
      };
    
      const submitValidate = () => {
        console.log(computedSchema)
        computedSchema.value
          .validate(sellerShippingLogistics, { abortEarly: false })
          .then()
          .catch((e) => {
            for (let i = 0; i < e.errors.length; i++) {
              store.dispatch(
                SHOW_TOAST_MESSAGE,
                GeneralHelper.buildMessage(3, e.errors[i])
              );
            }
          });
      };
      const submitBillingAddress = () => {
        computedSchema.value.isValid(sellerShippingLogistics).then(function(valid) {
          if (!props.showSave) emit("validated", valid);
        });
        if (props.showSave) {
            sellerShippingLogistics.order_kit_id = route.params['order_kit_id']
            store
              .dispatch(UPDATE_SELLER_SHIPPING_LOGISTICS, sellerShippingLogistics)
              .then(()=>{
                store.dispatch(
                    SHOW_TOAST_MESSAGE,
                    GeneralHelper.buildMessage(1, "Logistics Submitted Successfully!")
                  );

                router.push({name: "Home"});
              })
              .catch((e) => {
                if (e.response && e.response.data) {
                  store.dispatch(
                    SHOW_TOAST_MESSAGE,
                    GeneralHelper.buildMessage(3, e.response.data.message)
                  );
                }
              });
         
        }
      };
  
      return {
        submitValidate,
        submitBillingAddress,
        sellerShippingLogistics,
        computedSchema,
        init,
      };
    },

    computed:
    {
       
    },
  
    props: {
      data_: {
        default: {},
      },
      showSave: {
        default: true,
      },
      disabled: {
        default: false,
      },
    },
  };
  </script>
  
  <style lang="scss">
  
  @import '../../userdashboard/style/profile.scss';
  @media screen and (max-width:500px) {
    .p-dropdown-panel{
      width: 200px !important;
      min-width: 200px !important;
    }
    
    .p-dropdown-panel.p-dropdown-header{
      height: 30px !important;
      padding: 5px !important;
    }
  }
  .p-dropdown-filter.p-inputtext{
    height: 20px !important;
  }
  
  .p-dropdown-label{
    align-items: baseline !important;
  }
  
  .p-dropdown-item {
    padding: 5px !important;
    font-size: 13px !important;
  }
  
  </style>
  